import React, { Component } from 'react';
import Step from './Step';
import ShareButton from './ShareButton';
import logo from './logo.svg';
import './App.css';

function App() {
  let share = null;

  const doShare = () => {
    let resultPara = { textContent: ""}
    const shareData = {
      title: 'Yliskulma-tietovisa',
      text: 'Testaa mitä tiedät Yliskulmasta!',
      url: 'https://yliskulmavisa.web.app',
    }
      // Must be triggered some kind of "user activation"
    (async () => {
      try {
        await navigator.share(shareData)
        resultPara.textContent = 'MDN shared successfully'
      } catch(err) {
        resultPara.textContent = 'Error: ' + err
      }}
    )();
  }
  if( /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent) && navigator.share ) {
    share = <ShareButton/>
  } else {
    share =(<div className="fb-share-button" data-href="https://yliskulmavisa.web.app" data-layout="button" data-size="large"><a target="_blank" href="https://www.facebook.com/sharer/sharer.php?u=https%3A%2F%2Fyliskulmavisa.web.app%2F&amp;src=sdkpreparse" class="fb-xfbml-parse-ignore">Jaa</a></div>)
  }
  return (
    <div className="App">
      <header className="App-header">
        <Step/>
        {/*<a
          className="App-link"
          href="http://yliskulma.fi"
          target="_blank"
          rel="noopener noreferrer"
        >yliskulma.fi</a>*/}
        { share }
      </header>
    </div>
  );
}

export default App;
